/**
 * VueWysiwygHTML
 * ウィジウィグ内の要素を加工して置換します
 * ※ 現在はプロジェクト依存的な実装（TinyMCE Advancedのテーブル加工用）
 */
import directive from './directive'

const VueAHTML = {
  install: function(Vue, options) {

    Vue.directive('whtml', directive);
  }
}
export default VueAHTML



// WEBPACK FOOTER //
// ./src/plugins/vue-whtml/index.js